export default {
  title: 'Recibo impreso',
  form: {
    is_service_fee_hidden_on_receipt: {
      label: 'Ocultar cargo de servicio en el recibo',
    },
    is_price_section_hidden_on_receipt: {
      label: 'Ocultar sección de precios en el recibo',
    },
    is_modifier_group_hidden_on_receipt: {
      label: 'Ocultar nombres de grupos de modificadores en el recibo',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Cambios guardados',
  },
};
